export default __webpack_public_path__ + "static/media/logos_pstbn-02.9e3c21a5.png";